// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup_3uPht","heading":"heading_3pSn9","headingWrapper":"headingWrapper_3dn88","description":"description_1r0Zp","close":"close_35sOI","reload":"reload_RbP6c"};